var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWinArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.315,
    height: 8.206,
    viewBox: "0 0 12.315 8.206",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.487,1.4a.535.535,0,0,0,0-.144.438.438,0,0,0-.034-.116.752.752,0,0,0-.062-.1A.513.513,0,0,0,12.3.93L12.214.882a.473.473,0,0,0-.13-.068h-.137a.479.479,0,0,0-.144-.1H8.384a.684.684,0,0,0,0,1.368H10.32L7.584,5.306,4.63,3.549a.684.684,0,0,0-.875.15L.336,7.8a.685.685,0,0,0,1.053.875L4.432,5.026l2.92,1.751a.684.684,0,0,0,.868-.144l2.9-3.385V4.821a.684.684,0,1,0,1.368,0Z",
    transform: "translate(-0.177 -0.718)",
    fill: "#21edbd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWinArrow);
export default __webpack_public_path__ + "static/media/winArrow.2fa9496dc66e9bdc59080d3ff51e5d7f.svg";
export { ForwardRef as ReactComponent };